<div class="content" [ngClass]="{'content-vertical': !isHorizontal, 'content-horizontal': isHorizontal}">
    <ng-container *ngFor="let chartKey of objKeys(charts); trackById">
        <ng-container *ngIf="charts[chartKey]; let chart">
            <!-- <div [ngClass]="{'margin-horizontal': isHorizontal, 'margin-vertical': !isHorizontal}" style="flex-grow: 1; overflow: auto"> -->
            <div [ngClass]="{'margin-horizontal': isHorizontal, 'margin-vertical': !isHorizontal}" [ngStyle]="{'width': ui.style.width, 'height': ui.style.height}" style="overflow: auto">
                <div style="display: flex; height: 100%; width: 100%; flex-flow: column;">
                    <div style="display: flex; justify-content: space-between;">
                        <span>{{chart.name}}</span>
                        <span *ngIf="ui?.layout?.isDev">Setting icon</span>
                    </div>
                    <div style="flex: 1">
                        <!-- <ng-template dynamicAnchor></ng-template> -->
                        <div style="height: 100%">
                            <ng-container *ngTemplateOutlet="test"></ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>
</div>

<ng-template #test>
    <ng-template dynamicAnchor></ng-template>
</ng-template>